import { render } from "./SettingList.vue?vue&type=template&id=ad7fbb78&scoped=true"
import script from "./SettingList.vue?vue&type=script&lang=js"
export * from "./SettingList.vue?vue&type=script&lang=js"

import "./SettingList.vue?vue&type=style&index=0&id=ad7fbb78&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad7fbb78"]])

export default __exports__